import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import insiteTipSvg from '../assets/insiteTip.svg';
import outsiteTipSvg from '../assets/outsiteTip.svg';

const Icon = styled(InfoCircleOutlined)`
  cursor: pointer;
  .${({ theme }) => theme.getAntdPrefixedClassName('popover-arrow-content')} {
    background: #5287ff;
  }
`;

const Content = styled.ul`
  margin: -12px -16px;
  padding: 14px 14px 14px 26px;
  background: #5287ff;
  color: #fff;
  dt {
    margin-bottom: 10px;
    > span {
      font-size: 12px;
    }
  }
  dd {
    display: flex;
    > div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 6px;
      font-size: 12px;
    }
  }
`;

function Tip() {
  const { t } = useTranslate();

  return (
    <Popover
      placement="bottomRight"
      getPopupContainer={(trigger) => trigger}
      content={
        <Content>
          <li>
            <dt>
              {t('remind.会话列表')}
              <span>{`(${t('remind.站内提醒')})`}</span>
            </dt>
            <dd>
              <img src={insiteTipSvg} alt="insite" />
              <div>
                <span>{t('remind.特殊提醒效果')}</span>
                <span>{t('remind.无特殊提醒效果')}</span>
              </div>
            </dd>
          </li>
          <li>
            <dt>
              {t('remind.钉钉/企业微信')}
              <span>{`(${t('remind.站外提醒')})`}</span>
            </dt>
            <dd>
              <img src={outsiteTipSvg} alt="outsite" />
            </dd>
          </li>
        </Content>
      }
    >
      <Icon />
    </Popover>
  );
}

export default Tip;
